import getPatientNotes from './getPatientNotes';
import approveNote from './approveNote';
export default {
    getPatientNotes,
    approveNote
}